import { Trans, useLingui } from '@lingui/react/macro';
import { DiamondGrid, diamondGlows } from '../primitives';

/** The card pair is in percentages of the hand-off's 348px frame, so it scales down on a narrow screen rather than clipping. */
export function BCorp() {
	const { t } = useLingui();
	return (
		<section className="bg-ink relative overflow-hidden text-white">
			{/* Measured off the hand-off, not its alphas: ~0.26 top-right and ~0.51 bottom-left peak white. */}
			<DiamondGrid
				color="#FFFFFF"
				opacity={1}
				masks={[
					diamondGlows(
						{ x: 'calc(100% - 77px)', y: '76px', strength: 0.29 },
						{ x: '-35px', y: 'calc(100% + 6px)', strength: 0.83 },
					),
				]}
			/>

			<div className="relative mx-auto flex max-w-[1440px] flex-col items-start gap-12 px-6 py-16 md:py-20 xl:h-[784px] xl:flex-row xl:items-center xl:gap-0 xl:px-0 xl:py-0">
				<div className="flex w-full max-w-[700px] flex-col gap-4 xl:-mt-[15px] xl:ml-[127px]">
					<h2 className="text-4xl leading-[1.3] font-medium tracking-[-0.02em] md:text-[2.5rem]">
						{t`B Corp since 2015`}
					</h2>
					{/* The export's #A8ACAB is exactly white at 60% over this ink. */}
					<p className="text-base leading-[1.5] text-white/60">
						<Trans>
							We were one of the first companies in Spain to be awarded the B Corp certificate. This international seal,
							granted by B Lab, recognises companies meeting the highest standards of social and environmental
							performance, transparency and corporate accountability, guaranteeing that{' '}
							<strong className="font-semibold text-white">we pursue the common good ahead of profit alone.</strong>
						</Trans>
					</p>
				</div>

				<div className="relative mx-auto aspect-[348/438] w-full max-w-[348px] xl:absolute xl:top-[173px] xl:left-[967px] xl:mx-0">
					<div
						aria-hidden
						className="bg-sand absolute top-[8.3%] left-[8.8%] h-[88.3%] w-[85.6%] rotate-3 rounded-[34px]"
					/>
					{/* The export lifts it 8px above the frame. */}
					<div className="bg-olive absolute top-[-1.8%] left-0 flex h-[88.3%] w-[85.6%] items-center justify-center rounded-[34px] p-[28.2%]">
						<img src="/redesign/about/bcorp-certified.svg" alt={t`Certified B Corporation`} className="h-auto w-full" />
					</div>
				</div>
			</div>
		</section>
	);
}
